import { createElement } from "./create-element";
const offcanvasEls = document.querySelectorAll(".offcanvas");

try {
  offcanvasEls.forEach((offcanvasEl) => {
    const dropdownEls = offcanvasEl.querySelectorAll(".dropdown");
    const dropdownElsPreSorted = [];

    dropdownEls.forEach((dropdownEl, i) => {
      let element = dropdownEl;
      let count = 0;

      while (element.parentElement && offcanvasEl !== element) {
        count++;
        element = element.parentElement;
      }

      dropdownElsPreSorted.push({
        index: count,
        el: dropdownEl,
      });
    });

    const dropdownElsSorted = dropdownElsPreSorted
      .sort((a, b) => b.index - a.index)
      .map((obj) => obj.el);

    dropdownElsSorted.forEach((dropdownEl, i) => {
      const dropdownMenuEl = dropdownEl.querySelector(".dropdown-menu");
      const dropdownToggleEl = dropdownEl.querySelector(".dropdown-toggle");
      if (dropdownMenuEl && dropdownToggleEl) {
        const collapseId = `offcanvas-collapse-${i}`;

        dropdownEl.classList.remove("dropdown", "show");

        dropdownMenuEl.id = collapseId;
        dropdownMenuEl.classList.remove("dropdown-menu", "show");
        dropdownMenuEl.classList.add("collapse", "collapse-menu");
        dropdownMenuEl.removeAttribute("aria-labelledby");

        const collapseMenuEl = createElement("div", {
          id: collapseId,
          classes: ["collapse"],
        });

        collapseMenuEl.innerHTML = `<ul class="collapse-menu">${dropdownMenuEl.innerHTML}</ul>`;

        dropdownMenuEl.replaceWith(collapseMenuEl);

        dropdownToggleEl.removeAttribute("id");
        dropdownToggleEl.classList.remove("dropdown-toggle", "show");
        dropdownToggleEl.classList.add("collapse-toggle", "collapsed");
        dropdownToggleEl.setAttribute("data-bs-toggle", "collapse");
        dropdownToggleEl.setAttribute("role", "button");
        dropdownToggleEl.setAttribute("href", `#${collapseId}`);
        dropdownToggleEl.setAttribute("aria-expanded", "false");
        dropdownToggleEl.setAttribute("aria-controls", collapseId);
      }
    });
  });
} catch (error) {
  console.error(error);
}
